import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/KeyboardArrowDown';

class KeyboardArrowDownIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default KeyboardArrowDownIcon;
